import axios from "axios";
import { createStore } from "vuex";
import io from "socket.io-client";
import router from "@/router";

function parseStoredUser(rawUser: string | null) {
  if (!rawUser || rawUser === "undefined" || rawUser === "null") {
    return null;
  }

  try {
    return JSON.parse(rawUser);
  } catch (_error) {
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    return null;
  }
}

const parsedStoredUser = parseStoredUser(localStorage.getItem("user"));

const browserHost =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "127.0.0.1"
    : typeof window !== "undefined"
      ? window.location.hostname
      : "127.0.0.1";
const rootAPI =
  process.env.VUE_APP_ROOT_API || `http://${browserHost}:8000/api/passenger/`;
const rootSocket =
  process.env.VUE_APP_SOCKET_HOST || `http://${browserHost}:3000`;
const selectedLanguage = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
const socket: any = {};

export default createStore({
  state: {
    token: parsedStoredUser ? localStorage.getItem("access_token") || null : null,
    user: parsedStoredUser ? JSON.stringify(parsedStoredUser) : "",
    card: localStorage.getItem("ActiveCard") || 0,
    per: localStorage.getItem("permis") || 0,
    
    selectedLanguage:
      localStorage.getItem("selected_language") || selectedLanguage,
    rootAPI: rootAPI,
    rootSocket: rootSocket,
    socket: socket,
    cancellationReasons: [],
  },
  getters: {
    loggedIn(state) {
      return !!state.token && !!parseStoredUser(state.user);
    },
    getUser(state) {
      if (state.token != null) return parseStoredUser(state.user) || "";
      return "";
    },
    getActiveCard(state) {
      console.log("joines get active card");
      return state.card;
    },
    getPer(state) {
      console.log("joines get permision");
      return state.per;
    },
    getToken(state) {
      return state.token;
    },
    getRootAPI(state) {
      return state.rootAPI;
    },
  
   
    selectedLanguage(state) {
      return state.selectedLanguage;
    },
    getCancellationReasons(state) {
      return state.cancellationReasons;
    },
  },
  mutations: {
    retrieveToken(state, data) {
      state.token = data.token;
      state.user = data.user;
    },
    setCancellationReasons(state, value) {
      state.cancellationReasons = value;
    },
    destroyToken(state) {
      state.token = null;
      state.user = "";
      state.card = 0;
      state.per = 0;

      localStorage.removeItem("access_token");
      localStorage.removeItem("ActiveCard");
      localStorage.removeItem("user");
      localStorage.removeItem("permis");
      console.log("done");
    },
    disconnectSocket(state) {
      state.socket.disconnect();
      state.socket = {};
    },
    setLanguage(state, language) {
      state.selectedLanguage = language;
    },

    setPer(state, permis) {
      console.log("set per");
      state.per = permis;
      localStorage.setItem("permis", permis);
    },
  
  },
  actions: {
    retrieveToken(context, data) {
      if (!context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .post(rootAPI + "login", {
              username: data.username,
              password: data.password,
            })
            .then((response) => {

              const token = response.data.data.accessToken;
              const user = response.data.data;
              context.commit("retrieveToken", {
                token: token,
                user: JSON.stringify(user),
              });

              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("access_token", token);
              localStorage.setItem("selected_language", user.language);
              context.commit("setLanguage", user.language);
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              if (error.message == "Network Error" && !error.response)
                reject("Please check your Internet connection");
              else if (error.response) reject(error.response.data.message);
              else reject(error);
            });
        });
      }
    },
    retrieveUser(context, data) {
      if (!context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .post(rootAPI + "website-login", {
              token: data.token
            })
            .then((response) => {

              const token = response.data.data.accessToken;
              const user = response.data.data;
              context.commit("retrieveToken", {
                token: token,
                user: JSON.stringify(user),
              });

              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("access_token", token);
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              if (error.message == "Network Error" && !error.response)
                reject("Please check your Internet connection");
              else if (error.response) reject(error.response.data.message);
              else reject(error);
            });
        });
      }
    },
    destroyToken(context) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .put(rootAPI + "logout")
            .then((response) => {
              context.commit("destroyToken");
              console.log("done 2");
              resolve(response);
            })
            .catch((error) => {
              if (error.message == "Network Error" && !error.response) {
                reject("Please check your Internet connection");
              }
              reject(error.response.data.message);
            });
        });
      }
    },
    getOrders(context, type) {
      // get all the orders from the API
      // put them into the state
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .get(rootAPI + "booking", {
              params: { time: type },
            })
            .then((response) => {
              resolve(response.data.data);
            })
            .catch((error) => {
              if (error.message == "Network Error" && !error.response) {
                reject("Please check your Internet connection");
              } else {
                reject(error.response.data.message);
              }
            });
        });
      }
    },
    getOrdersPageData(context, data) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .get(rootAPI + "booking", {
              params: { page: data.page, time: data.type },
            })
            .then((response) => {
              if (response.data.data.data.length)
                resolve(response.data.data.data);
              else resolve("reached-maximum");
            })
            .catch((error) => {
              if (error.message == "Network Error" && !error.response) {
                reject("Please check your Internet connection");
              } else {
                reject(error.response.data.message);
              }
            });
        });
      }
    },
    initSocket({ state }) {
      if (state.socket.connected) return;

      /*
        Since watchers doesn't work probably on objects unless we use 'deep' argument
        assigning entirely new object to a property will trigger the watcher
        so below once the socket is connected the socket object will be assigned to the state
      */
      return new Promise((resolve, reject) => {
        const socket = io(`${rootSocket}/passengers`, {
          transportOptions: {
            polling: {
              extraHeaders: axios.defaults.headers.common,
            },
          },
        });

        socket.on("connect", () => {
          state.socket = socket;
          resolve(true);
        });

        socket.on("connect_error", () => {
          reject(false);
        });
      });
    },
  
    setLanguagePreference(context, language) {
      localStorage.setItem("selected_language", language);
      context.commit("setLanguage", language);
      return new Promise((resolve, reject) => {
        axios.post(rootAPI + "change-lang", {
          language: language
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            if (error.message == "Network Error" && !error.response) {
              reject("Please check your Internet connection");
            }
            reject(error.response.data.message);
          });
      });

    },
   
    getCancellationReasons({ commit, state }) {
      if (state.cancellationReasons.length > 0) {
        return state.cancellationReasons;
      }
      return new Promise((resolve, reject) => {
        axios.get(rootAPI + "cancellation-reasons")
          .then(res => {
            commit('setCancellationReasons', res.data.data || []);
            resolve(res.data.data);
          })
          .catch(err => {
            if (err.message == "Network Error" && !err.response) {
              reject("Please check your Internet connection");
            } else {
              reject(err.response.data.message);
            }
          })
      })
    },
  },
  modules: {},
});
